module.exports = __webpack_public_path__ + "static/media/cardsorting.65e05766.jpeg";